module.exports = __webpack_public_path__ + "img/familia.313159c2.svg";